import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import userAvatar from "../assets/img/img1.jpg";
import { dashboardMenu, applicationsMenu, pagesMenu, uiElementsMenu } from "../data/Menu";
import cnamgsMenu from "../data/cnamgsMenu";
import '../assets/css/sidebar.css';
import cnamgsCover from "../assets/img/cnamgs_cover.jpeg";
export default class Sidebar extends Component {
    toggleFooterMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest(".sidebar");
        parent.classList.toggle("footer-menu-show");
    }

    toggleSubMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest('.nav-item');
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
                node.classList.remove('show');
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle('show');
        if (this._scrollBarRef) {
            this._scrollBarRef.updateScroll();
        }
    }

    toggleMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest('.nav-group');
        parent.classList.toggle('show');
        if (this._scrollBarRef) {
            this._scrollBarRef.updateScroll();
        }
    }

    render() {
        const { user } = this.props;

        return (
            <div className="sidebar" style={{background:'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'}}>
                <div className="sidebar-header">
                    <img src={cnamgsCover} alt="CNAMGS" style={{ height: '60px' }} />
                </div>
                <PerfectScrollbar className="sidebar-body" ref={ref => this._scrollBarRef = ref}>
                    {/* Menu CNAMGS - Affiche selon le rôle de l'utilisateur connecté */}
                    {user && (
                        <div className="nav-group show">
                            <div className="nav-label" onClick={(e) => this.toggleMenu(e)}>
                                {user.role === 'patient' && ' Espace Patient'}
                                {user.role === 'doctor' && ' Espace Médecin'}
                                {user.role === 'pharmacist' && ' Espace Pharmacien'}
                                {user.role === 'admin' && ' Administration'}
                            </div>
                            <ul className="nav nav-sidebar">
                                {cnamgsMenu[user.role]?.map((item, key) => (
                                    <li key={key} className="nav-item">
                                        <NavLink to={item.link} className="nav-link">
                                            <i className={item.icon}></i>
                                            <span>{item.label}</span>
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Menu existant du template - affiché seulement si l'utilisateur n'est pas connecté */}
                    {!user && (
                        <>
                            <div className="nav-group show">
                                <div className="nav-label" onClick={(e) => this.toggleMenu(e)}>Dashboard</div>
                                {this.populateMenu(dashboardMenu)}
                            </div>
                            <div className="nav-group show">
                                <div className="nav-label" onClick={(e) => this.toggleMenu(e)}>Applications</div>
                                {this.populateMenu(applicationsMenu)}
                            </div>
                            <div className="nav-group show">
                                <div className="nav-label" onClick={(e) => this.toggleMenu(e)}>Pages</div>
                                {this.populateMenu(pagesMenu)}
                            </div>
                            <div className="nav-group show">
                                <div className="nav-label" onClick={(e) => this.toggleMenu(e)}>UI Elements</div>
                                {this.populateMenu(uiElementsMenu)}
                            </div>
                        </>
                    )}
                </PerfectScrollbar>
                <div className="sidebar-footer" style={{background:'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'}}>
                    <div className="sidebar-footer-top">
                        <div className="sidebar-footer-thumb">
                            <img src={userAvatar} alt="" />
                        </div>
                        <div className="sidebar-footer-body">
                            <h6><Link to="/profile">{user?.name || 'Invité'}</Link></h6>
                            <p>
                                {user?.role === 'patient' && 'Assuré CNAMGS'}
                                {user?.role === 'doctor' && 'Médecin'}
                                {user?.role === 'pharmacist' && 'Pharmacien'}
                                {user?.role === 'admin' && 'Administrateur'}
                                {!user && 'Non connecté'}
                            </p>
                        </div>
                        <Link onClick={this.toggleFooterMenu} to="" className="dropdown-link">
                            <i className="ri-arrow-down-s-line"></i>
                        </Link>
                    </div>
                    <div className="sidebar-footer-menu">
                        <nav className="nav">
                            <Link to="/pages/profile"><i className="ri-edit-2-line"></i> Modifier profil</Link>
                            <Link to="/pages/profile"><i className="ri-profile-line"></i> Voir profil</Link>
                        </nav>
                        <hr />
                        <nav className="nav">
                            <Link to="/pages/help"><i className="ri-question-line"></i> Centre d'aide</Link>
                            <Link to="/pages/settings"><i className="ri-lock-line"></i> Confidentialité</Link>
                            <Link to="/pages/settings"><i className="ri-user-settings-line"></i> Paramètres</Link>
                            {user && (
                                <Link to="/login" onClick={() => {
                                    localStorage.removeItem('user');
                                    window.location.href = '/login';
                                }}><i className="ri-logout-box-r-line"></i> Déconnexion</Link>
                            )}
                            {!user && (
                                <Link to="/login"><i className="ri-login-box-line"></i> Connexion</Link>
                            )}
                        </nav>
                    </div>
                </div>
            </div>
        )
    }

    populateMenu = (m) => {
        const menu = m.map((m, key) => {
            let sm;
            if (m.submenu) {
                sm = m.submenu.map((sm, key) => {
                    return (
                        <NavLink to={sm.link} className="nav-sub-link" key={key}>
                            {sm.label}
                        </NavLink>
                    )
                })
            }

            return (
                <li key={key} className="nav-item">
                    {(!sm) ? (
                        <NavLink to={m.link} className="nav-link">
                            <i className={m.icon}></i> 
                            <span>{m.label}</span>
                        </NavLink>
                    ) : (
                        <div onClick={this.toggleSubMenu} className="nav-link has-sub">
                            <i className={m.icon}></i> 
                            <span>{m.label}</span>
                        </div>
                    )}
                    {m.submenu && <nav className="nav nav-sub">{sm}</nav>}
                </li>
            )
        });

        return (
            <ul className="nav nav-sidebar">
                {menu}
            </ul>
        );
    }
}

window.addEventListener("click", function (e) {
    // Close sidebar footer menu when clicked outside of it
    let tar = e.target;
    let sidebar = document.querySelector(".sidebar");
    if (!tar.closest(".sidebar-footer") && sidebar) {
        sidebar.classList.remove("footer-menu-show");
    }

    // Hide sidebar offset when clicked outside of sidebar
    if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
        document.querySelector("body")?.classList.remove("sidebar-show");
    }
});

window.addEventListener("load", function () {
    let skinMode = localStorage.getItem("sidebar-skin");
    let HTMLTag = document.querySelector("html");

    if (skinMode) {
        HTMLTag.setAttribute("data-sidebar", skinMode);
    }
});